export default __webpack_public_path__ + "static/media/PAFI_LKTT 2025.aafc53da.pdf";